export const initialBlogs = [
  {
    id: 1,
    title: "10 Smart Investment Strategies for 2024",
    slug: "smart-investment-strategies-2024",
    excerpt: "Discover the best investment strategies to grow your wealth in the current market scenario.",
    content: `
      <h2>Smart Investment Strategies for 2024</h2>
      <p>As we navigate through 2024, smart investing requires a balanced approach. Here are 10 strategies to consider:</p>
      
      <h3>1. Start Early with SIPs</h3>
      <p>Systematic Investment Plans (SIPs) help you invest regularly and benefit from rupee cost averaging. Starting early gives you the power of compounding.</p>
      
      <h3>2. Diversify Your Portfolio</h3>
      <p>Don't put all eggs in one basket. Spread investments across equity, debt, gold, and real estate.</p>
      
      <h3>3. Emergency Fund First</h3>
      <p>Before investing, ensure you have 6-12 months of expenses in liquid assets.</p>
      
      <h3>4. Review Your Insurance</h3>
      <p>Adequate life and health insurance coverage is essential for financial protection.</p>
      
      <h3>5. Tax-Saving Investments</h3>
      <p>Utilize Section 80C, 80D, and other deductions to save taxes legally.</p>
      
      <h2>Conclusion</h2>
      <p>Smart investing is about discipline, patience, and continuous learning. Consult with our experts for personalized advice.</p>
    `,
    author: "Yagnesh Dole",
    image: "https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?w=800",
    tags: ["Investment", "Strategy", "2024"],
    views: 1250,
    isPublished: true,
    createdAt: "2024-01-15"
  },
  {
    id: 2,
    title: "Complete Guide to Mutual Fund Investing",
    slug: "mutual-fund-investing-guide",
    excerpt: "Learn everything about mutual funds - types, benefits, and how to choose the right funds.",
    content: `
      <h2>Complete Guide to Mutual Fund Investing</h2>
      
      <h3>What are Mutual Funds?</h3>
      <p>Mutual funds pool money from multiple investors to invest in stocks, bonds, and other securities.</p>
      
      <h3>Types of Mutual Funds</h3>
      <ul>
        <li><strong>Equity Funds:</strong> Invest in stocks, high growth potential</li>
        <li><strong>Debt Funds:</strong> Invest in bonds, stable returns</li>
        <li><strong>Hybrid Funds:</strong> Mix of equity and debt</li>
        <li><strong>ELSS Funds:</strong> Tax saving with 3-year lock-in</li>
      </ul>
      
      <h3>Benefits of Mutual Funds</h3>
      <ul>
        <li>Professional Management</li>
        <li>Diversification</li>
        <li>Affordable - Start with ₹500</li>
        <li>Liquidity</li>
        <li>Tax Benefits</li>
      </ul>
      
      <h3>How to Choose Mutual Funds?</h3>
      <p>Consider your risk appetite, investment horizon, and financial goals. Check fund performance, expense ratio, and fund manager track record.</p>
      
      <p>Contact us for personalized mutual fund recommendations!</p>
    `,
    author: "Yagnesh Dole",
    image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=800",
    tags: ["Mutual Funds", "Investment", "Guide"],
    views: 890,
    isPublished: true,
    createdAt: "2024-02-10"
  },
  {
    id: 3,
    title: "Retirement Planning: How Much Do You Need?",
    slug: "retirement-planning-guide",
    excerpt: "Calculate your retirement corpus and start planning today for a comfortable future.",
    content: `
      <h2>Retirement Planning Guide</h2>
      
      <h3>Why Retirement Planning is Important?</h3>
      <p>With increasing life expectancy and inflation, retirement planning has become crucial. Don't rely solely on pension or family support.</p>
      
      <h3>How Much Corpus Do You Need?</h3>
      <p>A general rule is to have 20-30 times your annual expenses. For example, if you spend ₹6 lakhs annually, you need ₹1.2-1.8 crores.</p>
      
      <h3>Investment Options for Retirement</h3>
      <ul>
        <li>NPS (National Pension System)</li>
        <li>Mutual Funds (especially balanced/hybrid funds)</li>
        <li>PPF (Public Provident Fund)</li>
        <li>Senior Citizen Savings Scheme</li>
        <li>Annuity Plans</li>
      </ul>
      
      <h3>Start Early, Retire Rich</h3>
      <p>If you start at 25, you need to save much less than starting at 35. Use our Retirement Calculator to plan better.</p>
      
      <p>Book a consultation with our retirement planning experts today!</p>
    `,
    author: "Yagnesh Dole",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800",
    tags: ["Retirement", "Planning", "Financial Freedom"],
    views: 2100,
    isPublished: true,
    createdAt: "2024-03-05"
  },
  {
    id: 4,
    title: "Health Insurance: Complete Buyer's Guide",
    slug: "health-insurance-buyers-guide",
    excerpt: "Everything you need to know before buying a health insurance policy.",
    content: `
      <h2>Health Insurance Buyer's Guide</h2>
      
      <h3>Why Health Insurance is Essential</h3>
      <p>Medical inflation is rising at 10-15% annually. A single hospitalization can wipe out years of savings.</p>
      
      <h3>Types of Health Insurance</h3>
      <ul>
        <li>Individual Plans</li>
        <li>Family Floater Plans</li>
        <li>Senior Citizen Plans</li>
        <li>Critical Illness Plans</li>
        <li>Top-up Plans</li>
      </ul>
      
      <h3>What to Look For?</h3>
      <ul>
        <li>Sum Insured - Adequate coverage (min ₹5-10 lakhs)</li>
        <li>Network Hospitals - Cashless facility</li>
        <li>Claim Settlement Ratio - Above 95% is good</li>
        <li>Waiting Period for Pre-existing diseases</li>
        <li>Co-payment clause</li>
        <li>No Claim Bonus</li>
      </ul>
      
      <h3>Tax Benefits under 80D</h3>
      <p>Premium paid for health insurance offers tax deduction up to ₹25,000 (₹50,000 for senior citizens).</p>
      
      <p>Contact us for best health insurance plans comparison and quotes!</p>
    `,
    author: "Yagnesh Dole",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800",
    tags: ["Health Insurance", "Guide", "Insurance"],
    views: 567,
    isPublished: true,
    createdAt: "2024-03-20"
  }
];